import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";
import Store from "./store";
import { SocketContextProvider } from "./socket/socket";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Store>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SocketContextProvider>
        <App />
        </SocketContextProvider>
      </ThemeProvider>
    </Store>
  // </React.StrictMode>
);

reportWebVitals();
